export const sslcPdfs = {
  "State Board": {
    
  },
};
